import {
  ENTER_OFFSET_PX,
  EXIT_OFFSET_PX,
  MAX_WAVE_DELAY_MS,
  WAVE_DISTANCE_EXPONENT,
  WAVE_STEP_MS,
  ROW_ANIMATION_DURATION_MS,
} from '../constants/animation.constants';

function getWaveDelay(rowIndex, firstRemovedIndex) {
  if (firstRemovedIndex < 0) {
    return 0;
  }

  const distance = Math.max(0, rowIndex - firstRemovedIndex);
  
  return Math.min(MAX_WAVE_DELAY_MS, Math.pow(distance, WAVE_DISTANCE_EXPONENT) * WAVE_STEP_MS);
}

export function measureRowPositions(elements) {
  const positions = new Map();
  elements.forEach((element, uuid) => positions.set(uuid, element.getBoundingClientRect().top));
  
  return positions;
}

export function resetRowStyles(elements) {
  elements.forEach(element => {
    element.style.transition = 'none';
    element.style.transform = '';
    element.style.opacity = '';
  });
}

export function animateRowExits(rows, elements) {
  rows.forEach(row => {
    const element = elements.get(row.uuid);
    
    if (!element) {
      return;
    }

    element.style.transition = `transform ${ROW_ANIMATION_DURATION_MS}ms ease, opacity ${ROW_ANIMATION_DURATION_MS}ms ease`;
    element.style.transform = `translateX(${EXIT_OFFSET_PX}px)`;
    element.style.opacity = '0';
  });
}

export function prepareRowTransitions({ rows, elements, previousIds, previousPositions, firstRemovedIndex }) {
  // Measure all destinations before writing styles to avoid repeated layouts.
  const nextPositions = measureRowPositions(elements);
  const transitions = [];

  rows.forEach((row, index) => {
    const element = elements.get(row.uuid);
    
    if (!element) {
      return;
    }

    const entering = !previousIds.has(row.uuid);
    const nextTop = nextPositions.get(row.uuid);
    const offset = entering ? ENTER_OFFSET_PX : (previousPositions.get(row.uuid) ?? nextTop) - nextTop;

    element.style.transition = 'none';
    element.style.transform = `translateY(${offset}px)`;
    element.style.opacity = entering ? '0' : '1';
    transitions.push({ element, delay: getWaveDelay(index, firstRemovedIndex) });
  });

  return transitions;
}

export function playRowTransitions(transitions) {
  transitions.forEach(({ element, delay }) => {
    element.style.transition = `transform ${ROW_ANIMATION_DURATION_MS}ms ease ${delay}ms, opacity ${ROW_ANIMATION_DURATION_MS}ms ease`;
    element.style.transform = '';
    element.style.opacity = '1';
  });
}
